const selectElement = document.getElementById('fulfillment-date-delivery');
const fulfillmentConstants = window.FulfillmentConstants || {};
const dateKey = fulfillmentConstants.DATE || 'selected_fulfillment_date';
const locationKey = fulfillmentConstants.LOCATION_ID || 'selected_location_id';
const storageDate = localStorage.getItem(dateKey);
// Update to select items from both regular grid and category grids
const items = document.querySelectorAll('#product-grid li, .menu-category-section .grid__item');

async function getCartVariantIdSet() {
  try {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) return new Set();
    const cart = await response.json();
    const cartItems = Array.isArray(cart.items) ? cart.items : [];
    const ids = cartItems
      .map((item) => String(item && item.variant_id != null ? item.variant_id : '').trim())
      .filter(Boolean);
    return new Set(ids);
  } catch (_error) {
    return new Set();
  }
}

function persistSelectedFulfillmentDate(selectedDateValue) {
  const normalizedDate = selectedDateValue == null ? '' : String(selectedDateValue);
  if (window.FulfillmentState && typeof window.FulfillmentState.set === 'function' && normalizedDate) {
    window.FulfillmentState.set(dateKey, normalizedDate);
  }

  try {
    if (normalizedDate) {
      localStorage.setItem(dateKey, normalizedDate);
    } else {
      localStorage.removeItem(dateKey);
    }
  } catch (e) {}

  return normalizedDate;
}

function isFulfillmentDraftMode() {
  return !!(window.FulfillmentState && typeof window.FulfillmentState.isDraftMode === 'function' && window.FulfillmentState.isDraftMode());
}

// Function to re-initialize variant filtering
function reinitializeVariantFilter() {
  if (typeof window.updateVariantFilter === 'function') {
    const currentCatalogId = window.getSelectedCatalogId ? window.getSelectedCatalogId() : null;
    window.updateVariantFilter(currentCatalogId);
  }
}

// Function to dispatch fulfillment date changed event
function dispatchFulfillmentDateChanged(selectedDateValue) {
  let eventDate = localStorage.getItem(dateKey);
  if (selectedDateValue != null && selectedDateValue !== '') {
    try {
      eventDate = persistSelectedFulfillmentDate(selectedDateValue) || eventDate;
    } catch (e) {}
  }
  const event = new CustomEvent('fulfillmentDateChanged', {
    detail: { date: eventDate }
  });
  window.dispatchEvent(event);
}

// Remove a variant from the cart by variant ID, returning the quantity removed.
async function removeProductFromCartByVariantId(variantId) {
  try {
    const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!cartResponse.ok) {
      return 0;
    }
    const cart = await cartResponse.json();
    const lineItem = Array.isArray(cart.items)
      ? cart.items.find((item) => item && String(item.variant_id) === String(variantId))
      : null;
    if (!lineItem || !lineItem.key) {
      return 0;
    }

    const quantityBeingRemoved = Number(lineItem.quantity) || 0;

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: lineItem.key,
        quantity: 0
      })
    });

    if (!response.ok) {
      return 0;
    }

    const updatedCart = await response.json();

    if (typeof window.updateCart === 'function') {
      try {
        window.updateCart(updatedCart);
      } catch (_e) {}
    }

    try {
      const cartUpdateEvent = new CustomEvent('cart:updated', { detail: { cart: updatedCart } });
      window.dispatchEvent(cartUpdateEvent);
    } catch (_e) {}

    return quantityBeingRemoved;
  } catch (_error) {
    return 0;
  }
}

// Function to process date availability for all items
async function processDateAvailability(selectedDate) {
  if (isFulfillmentDraftMode()) {
    return;
  }

  const cartVariantIds = await getCartVariantIdSet();
  let hasUnavailableItems = false;
  let removedCount = 0;

  for (const item of items) {
    const start = item.getAttribute('data-product-start-date');
    const end = item.getAttribute('data-product-end-date');
    const variantId = item.getAttribute('data-variant-id');
    
    if (start) {
      const launchDate = new Date(`${start}T00:00:00`);
      
      if (selectedDate >= launchDate) {
        if (end) {
          const endDate = new Date(`${end}T00:00:00`);
          
          if (selectedDate <= endDate) {
            const unavailabilityDiv = item.querySelector(".item-details > .grid__item_unavailable");
            const buttonContainer = item.querySelector(".item-details > .prod-button-container");
            
            if (unavailabilityDiv) {
              unavailabilityDiv.classList.add('hidden');
            }
            if (buttonContainer) {
              buttonContainer.style.display = 'flex';
            }
          } else {
            const endFriendly =
              ((endDate.getMonth() > 8) ? (endDate.getMonth() + 1) : ('0' + (endDate.getMonth() + 1))) +
              '/' +
              ((endDate.getDate() > 9) ? endDate.getDate() : ('0' + endDate.getDate())) +
              '/' +
              endDate.getFullYear();
            
            const unavailabilityDiv = item.querySelector(".item-details > .grid__item_unavailable");
            const buttonContainer = item.querySelector(".item-details > .prod-button-container");
            
            if (unavailabilityDiv) {
              unavailabilityDiv.classList.remove('hidden');
              unavailabilityDiv.innerHTML = `<p>Not Available after <br/> ${endFriendly}.</p>`;
            }
            if (buttonContainer) {
              buttonContainer.remove();
            }
            
            if (variantId && cartVariantIds.has(String(variantId).trim())) {
              hasUnavailableItems = true;
              removedCount += await removeProductFromCartByVariantId(variantId);
            }
          }
        } else {
          const unavailabilityDiv = item.querySelector(".item-details > .grid__item_unavailable");
          const buttonContainer = item.querySelector(".item-details > .prod-button-container");
          
          if (unavailabilityDiv) {
            unavailabilityDiv.classList.add('hidden');
          }
          if (buttonContainer) {
            buttonContainer.style.display = 'flex';
          }
        }
      } else {
        const startFriendly =
          ((launchDate.getMonth() > 8) ? (launchDate.getMonth() + 1) : ('0' + (launchDate.getMonth() + 1))) +
          '/' +
          ((launchDate.getDate() > 9) ? launchDate.getDate() : ('0' + launchDate.getDate())) +
          '/' +
          launchDate.getFullYear();
        
        const unavailabilityDiv = item.querySelector(".item-details > .grid__item_unavailable");
        const buttonContainer = item.querySelector(".item-details > .prod-button-container");
        
        if (unavailabilityDiv) {
          unavailabilityDiv.classList.remove('hidden');
          unavailabilityDiv.innerHTML = `<p>Not Available until <br/> ${startFriendly}.</p>`;
        }
        if (buttonContainer) {
          buttonContainer.remove();
        }
        
        if (variantId && cartVariantIds.has(String(variantId).trim())) {
          hasUnavailableItems = true;
          removedCount += await removeProductFromCartByVariantId(variantId);
        }
      }
    }
  }
  
  if (removedCount > 0) {
    const msg =
      removedCount === 1
        ? '⚠️ 1 item in your cart was not available for the selected date and has been removed.'
        : `⚠️ ${removedCount} items in your cart were not available for the selected date and have been removed.`;
    window.showWarningToast(msg);
  } else if (hasUnavailableItems) {
    window.showWarningToast('⚠️ Some items are not available for the selected date. Please review your cart before checkout.');
  }
  
  // Re-initialize variant filtering after date filtering
  reinitializeVariantFilter();
  
  // Ensure event detail and localStorage have the selected date (YYYY-MM-DD)
  const dateStr = selectedDate
    ? (selectedDate.getFullYear() +
        '-' +
        String(selectedDate.getMonth() + 1).padStart(2, '0') +
        '-' +
        String(selectedDate.getDate()).padStart(2, '0'))
    : null;
  dispatchFulfillmentDateChanged(dateStr);
  
  // Also dispatch location change event if location is selected
  if (localStorage.getItem(locationKey)) {
    const locationEvent = new CustomEvent('locationChanged');
    window.dispatchEvent(locationEvent);
  }
}

function parseStorageDateToDate(storageDate) {
  if (!storageDate) return null;
  const str = String(storageDate).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
    const parts = str.split('-').map(Number);
    const d = new Date(parts[0], parts[1] - 1, parts[2]);
    if (!Number.isNaN(d.getTime())) {
      d.setHours(0, 0, 0, 0);
      return d;
    }
  }
  if (str.indexOf('T') !== -1) {
    const datePart = str.split('T')[0];
    if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
      const parts = datePart.split('-').map(Number);
      const d = new Date(parts[0], parts[1] - 1, parts[2]);
      if (!Number.isNaN(d.getTime())) {
        d.setHours(0, 0, 0, 0);
        return d;
      }
    }
    const parsed = new Date(str);
    if (!Number.isNaN(parsed.getTime())) {
      parsed.setHours(0, 0, 0, 0);
      return parsed;
    }
  }
  const parsed = new Date(storageDate);
  if (!Number.isNaN(parsed.getTime())) {
    parsed.setHours(0, 0, 0, 0);
    return parsed;
  }
  return null;
}

if (storageDate) {
  const selectedDate = parseStorageDateToDate(storageDate) || new Date();
  selectedDate.setHours(0, 0, 0, 0);
  processDateAvailability(selectedDate);
} else {
  const rawToday = window.FulfillmentDateUtils?.getTodayDateForComparison?.();
  let selectedDate;
  if (rawToday instanceof Date) {
    selectedDate = new Date(rawToday.getTime());
    selectedDate.setHours(0, 0, 0, 0);
  } else {
    let parsed;
    const rawString = rawToday != null ? String(rawToday).trim() : '';
    if (/^\d{4}-\d{2}-\d{2}$/.test(rawString)) {
      const parts = rawString.split('-').map(Number);
      parsed = new Date(parts[0], parts[1] - 1, parts[2]);
    } else {
      parsed = rawToday != null ? new Date(rawToday) : new Date();
    }
    selectedDate = Number.isNaN(parsed.getTime()) ? new Date() : parsed;
    selectedDate.setHours(0, 0, 0, 0);
  }
  processDateAvailability(selectedDate);
}

if (selectElement) {
  selectElement.addEventListener('change', function () {
    const selectedValue = this.value;
    try {
      persistSelectedFulfillmentDate(selectedValue);
    } catch (e) {}
    const selectedDate = new Date(`${selectedValue}T00:00:00`);
    selectedDate.setHours(0, 0, 0, 0);
    processDateAvailability(selectedDate);
  });
}
